import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import Argon from "./plugins/argon-kit";
import VueI18n from "vue-i18n";
import "./registerServiceWorker";

import English from "./lang/en.json";
import Japanese from "./lang/jp.json";

Vue.config.productionTip = false;
Vue.use(Argon);
Vue.use(VueI18n);

const messages = {
  en: English,
  jp: Japanese
}

const userLang = navigator.language;

let lang = 'en';

if (userLang === 'ja' || userLang === 'ja-JP') lang = 'jp';
else lang = 'en';

const i18n = new VueI18n({
  locale: lang,
  messages
})

new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount("#app");
